import React from "react";
import DashboardMasterComponent from "../Dashboard/DashboardMaster";

function DashboardComponent() {
    return (
        <div className="animate-in fade-in duration-700">
            <DashboardMasterComponent />
        </div>
    );
}

export default DashboardComponent;
